/**
 * Adapter para la API de reportes de inventario
 * Adapter for inventory reports API
 */

import { HttpClient } from '@adapters/HttpClient';
import { InventoryApiResponse } from '../models/InventoryApiResponse';
import { InventoryFilters } from '../models/InventoryFilters';

export class InventoryApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Obtiene los datos del reporte de inventario
   * Gets inventory report data
   */
  async getInventoryReport(filters?: InventoryFilters): Promise<InventoryApiResponse> {
    try {
      console.log('🔍 InventoryApiAdapter - Getting inventory report:', { filters });

      // Construir parámetros de query
      // Build query parameters
      const params: Record<string, any> = {};

      if (filters) {
        if (filters.search) {
          params.search = filters.search;
        }
        if (filters.sales_filter) {
          params.sales_filter = filters.sales_filter;
        }
      }

      const response = await this.httpClient.get<InventoryApiResponse>(
        '/report/inventory',
        params
      );

      console.log('🔍 InventoryApiAdapter - Response received:', response);

      return response;
    } catch (error: any) {
      console.log('🔍 InventoryApiAdapter - Error:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }
}
